import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderBar from "../components/HeaderBar";
import Sidebar from "../components/Sidebar";
import "./DashboardLayout.css";

const { Content } = Layout;

export default function DashboardLayout() {
  return (
    <Layout className="dashboard-layout">
      {/* ── Full-width Header ─────────────────────────── */}
      <HeaderBar />

      {/* ── Sidebar + Content ─────────────────────────── */}
      <Layout className="dashboard-body">
        <Sidebar />

        <Layout className="dashboard-main">
          {/* ── Scrollable Content ────────────────────── */}
          <Content className="dashboard-content">
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
}
